<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateDefect"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('production.defects_categories')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillDefectsCategoryForm="fillDefectsCategoryForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('production.defects')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillDefectsCategoryForm="fillDefectsCategoryForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.category') }}:</strong>
                        </h6>
                        {{ defectsCategoryForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('production.defects') }}:</strong>
                        </h6>
                        <span
                          v-for="(
                            defect, index
                          ) in defectsCategoryForm.defectName"
                          :key="index"
                        >
                          <el-tag
                            :type="
                              defectsCategoryForm.enable[index]
                                ? `info`
                                : `danger`
                            "
                            >{{ defect }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.companies2') }}:</strong>
                        </h6>
                        <span
                          v-for="(
                            _, index
                          ) in defectsCategoryForm.businesses_names"
                          :key="index"
                        >
                          <el-tag type="info">
                            {{ defectsCategoryForm.businesses_names[index] }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      title: '',
      defectsCategoryForm: {
        defectId: [],
        defectName: [],
        enable: [true],
      },
      wizardModel: {},
      map: null,
      renderComponent: true,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        id: null,
        name: null,
        businesses_id: [],
        businesses_names: [],
      };
      this.$refs.secondStep.model = {
        defectId: [],
        defectName: [],
        enable: [true],
        defect_number: 0,
      };
      this.$refs.firstStep.$refs['select-businesses'].model = {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillDefectsCategoryForm(ref, others) {
      this.defectsCategoryForm = Object.assign(
        {},
        this.defectsCategoryForm,
        this.$refs[ref].model
      );

      if (others)
        this.defectsCategoryForm = Object.assign(
          {},
          this.defectsCategoryForm,
          others
        );
    },

    storeUpdateDefect() {
      this.showHideLoading(true);
      this.defectsCategoryForm.route = 'quality/defectsCategories';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.defectsCategoryForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.defectsCategoryForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/defectsCategories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.defectsCategoryForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/defectsCategories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
            this.showHideLoading();
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('quality/defectsCategories');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('quality/defectsCategories');
  },
};
</script>
